import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getInitials } from 'shared/utils';
import { FullStoryExclude, FullStoryMask } from '../../../../shared/fullstory_privacy';
const nameCss = "n12zvfy3";
const Name = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(nameCss, props.className)} />;
});
const wrapperCss = "wwtzvzo";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const FullContact = ({
  contact
}) => {
  const name = contact.name;
  const initials = getInitials(name);
  const avatarSrc = contact?.contactAttributes?.avatar || contact?.enrichmentAttributes?.avatar;
  return <Wrapper>
      <FullStoryExclude>
        <Avatar letter={initials} src={avatarSrc} aria-label={name} tooltip={name} size="x-small" />
      </FullStoryExclude>
      <Name>
        <BodyText size="medium"><FullStoryMask>{name}</FullStoryMask></BodyText>
      </Name>
    </Wrapper>;
};
const UnauthorizedContact = () => <Wrapper>
    <Avatar size="x-small" />
    <Name>
      <BodyText size="medium">{I18n.t('publisher.scheduling.single_use_links.contacts.private_contact')}</BodyText>
    </Name>
  </Wrapper>;
export const ContactAvatar = ({
  contact
}) => {
  switch (contact.status) {
    case 'found':
      return <FullContact contact={contact} />;
    case 'unauthorized':
      return <UnauthorizedContact />;
    default:
      return null;
  }
};

require("./contact_avatar.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./contact_avatar.js");